import React from 'react'
import styles from './AddEditComment.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { observer } from 'mobx-react'
import TextareaMarkup from 'components/UI/TextareaMarkup/TextareaMarkup'

const AddEditComment = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  return (
    <div className={styles.groupForm}>
      <FormField>
        <FormLabel>Комментарий:</FormLabel>
        <TextareaMarkup
          stateName='comment'
          value={modalValue.comment}
          onChange={(e) => changeValues(e, 'comment')}
          error={check('comment')}
          placeholder={'Введите комментарий'}
        />
      </FormField>
    </div>
  )
}

export default observer(AddEditComment)
